jQuery(document).ready(function() {
  jQuery('.testimonial-slider').bxSlider({
    mode: 'fade',
    controls: false,
    auto: true,
    pause: 10000,
    responsive: true,
    pager: false,
    wrapperClass: 'bx-wrapper small-12'
  });

  jQuery('.bx-viewport').addClass('grid-x');

  jQuery('.home-slides-mobile').bxSlider({
    mode: 'fade',
    controls: false,
    auto: true,
    pause: 10000,
    responsive: true,
    pager: false,
    controls: true
  });
});
